module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/4/1-e751744133ba664fcebb1917a6f91996.jpg";